import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'HIPAA Compliant',
      description: 'Healthcare data protection'
    },
    {
      icon: 'Lock',
      title: 'SSL Encrypted',
      description: 'Secure data transmission'
    },
    {
      icon: 'FileCheck',
      title: 'SOC 2 Certified',
      description: 'Industry security standards'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="text-center mb-4">
        <h3 className="text-sm font-medium text-foreground mb-2">Your Data is Protected</h3>
        <p className="text-xs text-muted-foreground">
          We follow strict healthcare industry standards to keep your medical information secure
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex flex-col items-center text-center p-3 bg-muted/30 rounded-lg">
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center mb-2">
              <Icon name={feature?.icon} size={16} color="var(--color-success)" />
            </div>
            <div className="text-xs font-medium text-foreground">{feature?.title}</div>
            <div className="text-xs text-muted-foreground mt-1">{feature?.description}</div>
          </div>
        ))}
      </div>
      <div className="text-center mt-4">
        <p className="text-xs text-muted-foreground">
          © {new Date()?.getFullYear()} MycoMind. All rights reserved. | 
          <span className="ml-1">Medical data handled with care</span>
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;